import React, { useState, useEffect } from "react";

import moment from "moment";
import { toast } from "react-toastify";
import Table from "./Component.js";

import * as Constant from "../../../../Constant.js";

const AcceptContractTable = ({ tableId, bizApp, serviceAppList, appAuthTypeList, list, branchName, changeList, acceptFunc }) => {
    useEffect(() => {
        return () => {};
    }, [bizApp, serviceAppList, appAuthTypeList, list]);

    if(!bizApp || !serviceAppList || !appAuthTypeList) {
        return <></>;
    }

    let age = 0;
    let ageNum = 0;
    const colSpanApp = serviceAppList.reduce((acc, a) => bizApp[a.key] ? (acc + (bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd)) : acc, 0);
    return (
        <>
            <table className="table table-bordered table-contract table-contract-accept" id={tableId || "contractInfoTable"}>
                <Table.Header.Default bizApp={bizApp} serviceAppList={serviceAppList} />
                <tbody>
                    {!list && (
                        <tr>
                            <td
                                style={{ backgroundColor: "#ffffff" }}
                                colSpan={4 + colSpanApp}
                            >
                                승인을 기다리는 계약이 존재하지 않습니다.
                            </td>
                        </tr>
                    )}
                    {list &&
                        list.map((c, idx) => {
                            const chageAge = age === c.display_order;
                            if (!chageAge) {
                                age = c.display_order;
                                ageNum = 1;
                            } else {
                                ageNum++;
                            }
                            if (c.is555) return null;
                            const hasWaiting = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && (c.app_auth[a.key].approval == "WT") == true), false);
                            const hasApprovalOrg = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && (c.app_auth[a.key].approval_org == "WT" || c.app_auth[a.key].approval_org == "AP") == true), false);
                            
                            return (
                                <tr className="table-contract-tr" style={{ borderTop: `${chageAge ? "1" : "1"}px solid #e6e6f2` }} key={`table-contract-tr-accept-${idx}`}>
                                    <td className="table-contract-td col-fixed">{c.user_id || "-"}</td>
                                    <td className="table-contract-td col-fixed" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                        {c.class_name}
                                    </td>
                                    <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                        {hasWaiting ? (
                                            <Table.QuantityInput auth={hasWaiting ? "AP" : "NA"} value={c.quantity} disabled={!hasWaiting} lock={!hasWaiting} max={Constant.CONTRACT_LIMIT.HQ}
                                                quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(bizApp.tomonote.info, list, idx, val, callback)}
                                                quantityHandler={(val) => Table.func.quantityHandler(bizApp.tomonote.info, list, idx, val, changeList)} />
                                        ) : (
                                            <>{c.quantity}</>
                                        )}
                                    </td>
                                    <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                        {hasWaiting ? (
                                                <Table.DeviceSelect approval={hasWaiting} approval_org={hasApprovalOrg} device={c.device} onSelectHandler={(val) => Table.func.deviceHandler(list, idx, val, changeList)} />
                                        ) : (
                                            <>{!c.device ? '' : (c.device == 'tablet' ? '태블릿' : '전자칠판')}</>
                                        )}
                                    </td>
                                    <td className={`table-contract-td bg-union-70 ${'text-gray'}`} style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                                        <Table.UnionSelect classAuth={c.app_auth} union={c.unionId} appAuthTypeList={appAuthTypeList}
                                            disabled={false}
                                            onSelectHandler={(val) => Table.func.unionHandler(appAuthTypeList, list, idx, val, changeList)} />
                                    </td>
                                {serviceAppList ? (
                                    serviceAppList.map((a) => {
                                        if(a.contractUseTas && bizApp[a.key]) {
                                            return (
                                                <Table.AcceptCell
                                                    bizApp={bizApp[a.key]}
                                                    fold={bizApp[a.key].fold}
                                                    age={c[a.age.field]}
                                                    quantity={c[a.quantity.field[0]]}
                                                    auth={c.app_auth[a.key] ? c.app_auth[a.key].approval : "NA"}
                                                    auth_org={c.app_auth[a.key] ? c.app_auth[a.key].approval_org : "NA"}
                                                    canChangeNoAuth={true}
                                                    authHandler={(auth) => {
                                                        const _list = [...list];
                                                        if (!_list[idx].app_auth[a.key]) {
                                                            _list[idx].app_auth[a.key] = {
                                                                approval: "NA",
                                                                authType: null,
                                                                start_date: bizApps[a.key].start_date,
                                                                end_date: bizApps[a.key].end_date,
                                                            };
                                                        }
                                                        if (_list[idx].id > 0 && _list[idx].app_auth[a.key].approval_org === "AP") {
                                                            if (auth.age === -1) {
                                                                alert("승인된 계정의 미사용 처리는 불가능합니다.");
                                                            } else {
                                                                _list[idx].age = auth.age;
                                                                _list[idx].app_auth[a.key].authType = null;
                                                            }
                                                        } else {
                                                            if (auth.age === -1) {
                                                                const [checkUnionOk, unbindUnionResult] = Table.func.checkUnionUnbind(a.key, list, idx);
                                                                if(checkUnionOk || unbindUnionResult) {
                                                                    _list[idx].app_auth[a.key].approval = "NA";
                                                                    if(unbindUnionResult) {
                                                                        Table.func.unionHandler(appAuthTypeList, _list, idx, null, changeList);
                                                                    }
                                                                } else {
                                                                    return;
                                                                }
                                                            } else {
                                                                _list[idx].app_auth[a.key].approval = "WT";
                                                                _list[idx][a.age.field] = auth.age;
                                                            }
                                                        }
        
                                                        changeList(_list);
                                                        if (_list[idx].app_auth[a.key].approval != "NA") {
                                                            bizApp[a.key].onChangeBizAppFold(a.key, bizApp, false);
                                                        }
                                                    }}
                                                    authTypeList={bizApp[a.key].authTypeList}
                                                    authType={c.app_auth[a.key] ? c.app_auth[a.key].authType : null}
                                                    authTypeHandler={(authType) => {
                                                        const _list = [...list];
                                                        _list[idx].app_auth[a.key].authType = authType;
                                                        _list[idx].app_auth[a.key].authTypeName = bizApp[a.key].authTypeList.find((at) => authType == at.type).name;
                                                        changeList(_list);
                                                    }}
                                                    quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(a, list, idx, val, callback)}
                                                    quantityHandler={(val) => Table.func.quantityHandler(a, list, idx, val, changeList)}
                                                    startDate={new Date(c.app_auth[a.key] ? c.app_auth[a.key].start_date : null)}
                                                    startDateHandler={(date) => Table.func.startDateHandler(a.key, list, idx, date, changeList)}
                                                    endDate={new Date(c.app_auth[a.key] ? c.app_auth[a.key].end_date : null)}
                                                    endDateHandler={(date) => Table.func.endDateHandler(a.key, list, idx, date, changeList)}
                                                    disabled={!c.app_auth[a.key] || c.app_auth[a.key].approval_org !== "WT"}
                                                    is555={c.is555}
                                                />
                                            );
                                        }})
                                    ) : (
                                        <></>
                                    )}
                                </tr>
                            );
                        })}
                </tbody>
                {list && list.length > 0 && (
                    <tfoot>
                        <tr className="table-contract-tr">
                            <td colSpan="2" className="bg-dark text-light text-center font-bold">
                                합계
                            </td>
                            <td colSpan="2" className="bg-dark text-light text-center font-bold">
                            </td>
                            <td style={{ backgroundColor: "#f9f9ff" }}></td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizApp[a.key]) {
                                        return (
                                            <>
                                                <td style={{ backgroundColor: "#f9f9ff" }} colSpan={bizApp[a.key].fold || bizApp[a.key].hasCellQuantity ? 1 : 1 + bizApp[a.key].colAdd}>
                                                    {bizApp[a.key].count}개 {bizApp[a.key].fold && bizApp[a.key].hasCellQuantity ? ` / ${bizApp[a.key].quantity}명` : ``}
                                                </td>
                                                {!bizApp[a.key].fold && bizApp[a.key].hasCellQuantity && (<td style={{ backgroundColor: "#f9f9ff" }}>{bizApp[a.key].quantity}명</td>)}
                                                {!bizApp[a.key].fold && (
                                                    <td style={{ padding: "3px" }}>
                                                        <button
                                                            className="btn btn-purple btn-rounded"
                                                            onClick={() => {
                                                                if (acceptFunc) acceptFunc(a.key);
                                                            }}
                                                            disabled={bizApp[a.key].count_new <= 0 || bizApp[a.key].quantity <= 0}
                                                        >
                                                            적용
                                                        </button>
                                                    </td>
                                                )}
                                            </>
                                        );
                                    }})
                                ) : (
                                    <></>
                                )}
                        </tr>
                        <tr className="table-contract-tr">
                            <td colSpan="2" className="bg-dark text-light text-center font-bold">
                                기존 승인 건
                            </td>
                            <td colSpan="2" className="bg-dark text-light text-center font-bold">
                            </td>
                            <td style={{ backgroundColor: "#f9f9ff" }}></td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizApp[a.key]) {
                                        return (
                                            <>
                                                <td style={{ backgroundColor: "#f9f9ff" }} colSpan={bizApp[a.key].fold || bizApp[a.key].hasCellQuantity ? 1 : 1 + bizApp[a.key].colAdd}>
                                                    {bizApp[a.key].count_org}개 {bizApp[a.key].fold && bizApp[a.key].hasCellQuantity ? ` / ${bizApp[a.key].quantity_org}명` : ``}
                                                </td>
                                                {!bizApp[a.key].fold && bizApp[a.key].hasCellQuantity && (<td style={{ backgroundColor: "#f9f9ff" }}>{bizApp[a.key].quantity_org}명</td>)}
                                                {!bizApp[a.key].fold && (
                                                    <td style={{ padding: "3px" }}>
                                                    </td>
                                                )}
                                            </>
                                        );
                                    }})
                                ) : (
                                    <></>
                                )}
                        </tr>
                        <tr>
                            <td colSpan="2" className="bg-dark text-light text-center font-bold">
                                계약 지사
                            </td>
                            <td colSpan="2" className="bg-dark text-light text-center font-bold">
                            </td>
                            <td style={{ backgroundColor: "#f9f9ff" }}></td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizApp[a.key]) {
                                        return (
                                            <td style={{ backgroundColor: "#f9f9ff" }} colSpan={bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd}>
                                                {bizApp[a.key].hasPreContractedBranch ? '' : branchName[a.key]}
                                            </td>
                                        );
                                    }})
                                ) : (
                                    <></>
                                )}
                        </tr>
                    </tfoot>
                )}
            </table>
        </>
    );
};

export default {
    AcceptTable: AcceptContractTable,
};
